export const formFields = [
    // Personal Information
    {
        name: 'title',
        label: 'Title',
        type: 'select',
        options: ['Dr', 'Mr', 'Miss', 'Mrs'],
        required: true,
        row: 1,
        col: 3,
    },
    {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        placeholder: 'Enter your first name',
        required: true,
        validation: {
            regex: /^[a-zA-Z\s]+$/,
            errorMessage: 'Only alphabets allowed',
        },
        maxLength: 50,
        row: 1,
        col: 3,
        className: 'custom-first-name',
    },
    {
        name: 'middleName',
        label: 'Middle Name',
        type: 'text',
        placeholder: 'Enter your middle name',
        required: false,
        validation: {
            regex: /^[a-zA-Z\s]+$/,
            errorMessage: 'Only alphabets allowed',
        },
        isDisabled: false,
        maxLength: 50,
        row: 1,
        col: 3,
        className: 'custom-middle-name',
    },
    {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        placeholder: 'Enter your last name',
        required: true,
        validation: {
            regex: /^[a-zA-Z\s]+$/,
            errorMessage: 'Only alphabets allowed',
        },
        maxLength: 50,
        row: 1,
        col: 3,
    },
    {
        name: 'dob',
        label: 'Date of Birth',
        type: 'date',
        required: true,
        validation: {
            custom: (value) => new Date().getFullYear() - new Date(value).getFullYear() >= 18,
            errorMessage: 'Must be 18 years or older',
        },
        row: 2,
        col: 3,
    },
    {
        name: 'gender',
        label: 'Gender',
        type: 'select',
        options: ['Male', 'Female', 'Other'],
        required: true,
        row: 2,
        col: 3,
    },
    {
        name: 'mobile',
        label: 'Mobile Number 1',
        type: 'text',
        placeholder: 'Enter your mobile number',
        required: true,
        validation: {
            regex: /^[0-9]{10}$/,
            errorMessage: 'Invalid mobile number',
        },
        maxLength: 10,
        row: 2,
        col: 3,
    },
    {
        name: 'mobile1',
        label: 'Mobile Number 2',
        type: 'text',
        placeholder: 'Enter your mobile number',
        required: false,
        validation: {
            regex: /^[0-9]{10}$/,
            errorMessage: 'Invalid mobile number',
        },
        maxLength: 10,
        row: 2,
        col: 3,
    },
    {
        name: 'email',
        label: 'Email',
        type: 'email',
        placeholder: 'Enter your email',
        required: true,
        validation: {
            regex: /^(?=.{1,75}$)[^\s@]+@[^\s@]+\.[^\s@]+$/,
            errorMessage: 'Invalid email format',
        },
        maxLength: 75,
        row: 3,
        col: 6,
    },
    {
        name: "file1",
        label: "Upload User Photograph",
        type: "file",
        accept: ["image/png", "image/jpeg", "image/jpg"], // Allowed file types
        maxSize: 200 * 1024, // Maximum file size in bytes (5MB here)
        required: true,
        infoBottom: {
            message: "Media file should be less than 200KB (.jpg, .jpeg, .png format).",
        },
        row: 3,
        col: 6,
    },
    {
        name: 'IDProofNumber',
        label: 'ID Proof Number',
        type: 'text',
        placeholder: 'Aadhar card, driving license, Passport No, etc',
        validation: {
            regex: /^[a-zA-Z0-9\s]{2,30}$/,
            errorMessage: 'Invalid format',
        },
        required: true,
        maxLength: 30,
        row: 4,
        col: 6,
    },
    {
        name: "file2",
        label: "Upload ID Proof",
        type: "file",
        accept: ["image/png", "image/jpeg", "image/jpg", "application/pdf"], // Allowed file types
        maxSize: 200 * 1024, // Maximum file size in bytes (5MB here)
        required: true,
        infoBottom: {
            message: "Media file should be less than 200KB (.jpg, .jpeg, .png or .pdf format).",
        },
        row: 4,
        col: 6,
    },
    {
        name: 'qualId',
        label: 'Qualification',
        type: 'select',
        options: [], // Populate dynamically
        required: true,
        row: 5,
        col: 6,
    },
    {
        name: "file3",
        label: "Upload Degree/Diploma Certificate",
        type: "file",
        accept: ["image/png", "image/jpeg", "image/jpg", "application/pdf"], // Allowed file types
        maxSize: 500 * 1024, // Maximum file size in bytes (5MB here)
        required: true,
        infoBottom: {
            message: "Media file should be less than 500KB (.jpg, .jpeg, .png or .pdf format).",
        },
        row: 5,
        col: 6,
    },
    {
        name: 'desgId',
        label: 'Designation',
        type: 'select',
        options: [], // Populate dynamically
        required: true,
        row: 6,
        col: 6,
    },
    {
        name: 'instituteName',
        label: 'Organization',
        type: 'text',
        placeholder: 'Enter your organization name',
        required: true,
        validation: {
            regex: /^[A-Za-z()& \s]{2,250}$/,
            errorMessage: 'Enter a correct Organization',
        },
        row: 6,
        col: 6,
    },
    {
        name: 'address',
        label: 'Address',
        type: 'textarea',
        placeholder: 'Enter your address',
        required: true,
        maxLength: 200,
        row: 7,
        col: 12,
    },
    {
        name: 'pincode',
        label: 'Pincode',
        type: 'text',
        placeholder: 'Pincode',
        maxLength: 6,
        required: true,
        validation: {
            regex: /^[1-9][0-9]{5}$/,
            errorMessage: 'Enter a valid 6-digit Pincode',
        },
        row: 8,
        col: 3,
    },
    {
        name: 'countryId',
        label: 'Country',
        type: 'select',
        options: [], // Populate dynamically
        required: true,
        row: 8,
        col: 3,
    },
    {
        name: 'stateId',
        label: 'State',
        type: 'select',
        options: [], // Populate dynamically
        required: true,
        visibilityDependencies: {
            field: 'countryId',
            condition: (value) => value !== '2', // Show when countryId has a specific value (!==) means it will be visible for anything but 2
        },
        row: 8,
        col: 3,
    },
    {
        name: 'otherCountry',
        label: 'Country Name',
        type: 'text',
        placeholder: 'Country',
        required: false,
        validation: {
            regex: /^[a-zA-Z\s]+$/,
            errorMessage: 'Enter your Country',
        },
        visibilityDependencies: {
            field: 'countryId',
            condition: (value) => value === '2', // Show when countryId has a specific value of 2 i.e. Other Country
        },
        requireDependencies: {
            field: 'countryId',
            condition: (value) => value === '2',
        },
        maxLength: 65,
        row: 8,
        col: 3,
    },
    {
        name: 'city',
        label: 'City',
        type: 'text',
        placeholder: 'City',
        required: true,
        validation: {
            regex: /^[a-zA-Z\s]+$/,
            errorMessage: 'Enter your City',
        },
        maxLength: 45,
        row: 8,
        col: 3,
    }
];
